export default __webpack_public_path__ + "static/media/DryOasis.f6813a28.jpg";